import { Theme, createStyles, makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    copyCodeButton: {
      borderRadius: '0.75rem',
      maxHight: '2.25rem',
      padding: '0.5rem',
      textTransform: 'none',
      '&:hover': {
        background: '#0094FF',
        filter: 'brightness(0.9)',
      },
      background: '#0094FF',
      color: ' #fff',
    },
    item: {
      fontWeight: 420,
      margin: '0.5rem 0',
    },
  }),
);

export default useStyles;
